import { useCallback } from 'react'
import { useBottomSheet } from '../../../../../../state-management/contexts/BottomSheetContext'
import { lightImpactVibrate } from '../../../../../../utils/appBridge'
import { SipRecommendationActionType } from '../../api/common.types'
import { SipDecreasePlanRecommendationContainer } from '../decrease/SipDecreasePlanRecommendationContainer'
import { SipIncreasePlanRecommendationContainer } from '../increase/SipIncreasePlanRecommendationContainer'
import { IdealSipPlanRecommendationContainer } from '../ideal/IdealSipPlanRecommendationContainer'
import { SipStartPlanRecommendationContainer } from '../start/SipStartPlanRecommendationContainer'
import { SipStopPlanRecommendationContainer } from '../stop/SipStopPlanRecommendationContainer'
import {
  isSipPlanRecommendationBottomSheetBucket,
  resolveSipRecommendationAction,
  type IdealSipPlanRecommendationOpenParams,
  type SipPlanRecommendationOpenParams
} from './planRecommendationOpen'

export function useOpenSipPlanRecommendationBottomSheet() {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const openSipPlanRecommendationBottomSheet = useCallback(
    (input: SipPlanRecommendationOpenParams) => {
      const isin = input.isin ?? ''
      if (!isin || !isSipPlanRecommendationBottomSheetBucket(input.bucketType)) {
        return
      }

      const recommendationAction = resolveSipRecommendationAction(
        input.bucketType,
        input.recommendationAction
      )
      if (recommendationAction == null) {
        return
      }

      const containerProps = {
        onDismiss: closeBottomSheet,
        isin,
        totalIdealSipAmount: input.totalIdealSipAmount,
        recommendation: input.recommendation,
        initiateSipCta: input.initiateSipCta,
        manageSipCta: input.manageSipCta
      }

      lightImpactVibrate()
      if (recommendationAction === SipRecommendationActionType.START) {
        openBottomSheet(<SipStartPlanRecommendationContainer {...containerProps} />)
        return
      }
      if (recommendationAction === SipRecommendationActionType.STOP) {
        openBottomSheet(<SipStopPlanRecommendationContainer {...containerProps} />)
        return
      }
      if (recommendationAction === SipRecommendationActionType.INCREASE) {
        openBottomSheet(<SipIncreasePlanRecommendationContainer {...containerProps} />)
        return
      }
      openBottomSheet(<SipDecreasePlanRecommendationContainer {...containerProps} />)
    },
    [closeBottomSheet, openBottomSheet]
  )

  const openIdealSipPlanRecommendationBottomSheet = useCallback(
    (input: IdealSipPlanRecommendationOpenParams) => {
      const isin = input.isin ?? ''
      if (!isin) {
        return
      }

      lightImpactVibrate()
      openBottomSheet(
        <IdealSipPlanRecommendationContainer
          onDismiss={closeBottomSheet}
          isin={isin}
          totalIdealSipAmount={input.totalIdealSipAmount}
        />
      )
    },
    [closeBottomSheet, openBottomSheet]
  )

  return {
    openSipPlanRecommendationBottomSheet,
    openIdealSipPlanRecommendationBottomSheet
  }
}
